var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "More_-_Active_Hover",
    "data-name": "More - Active/Hover",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#e0001b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-more-horiz",
    "data-name": "Icon metro-more-horiz",
    d: "M9.381,15.424a1.669,1.669,0,1,0,1.669,1.669A1.668,1.668,0,0,0,9.381,15.424Zm10.013,0a1.669,1.669,0,1,0,1.669,1.669A1.668,1.668,0,0,0,19.395,15.424Zm-5.007,0a1.669,1.669,0,1,0,1.669,1.669A1.668,1.668,0,0,0,14.388,15.424Z",
    transform: "translate(-3.957 -6.526)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreRed);
export default __webpack_public_path__ + "static/media/More-red.8ce42201c6bc97d2c800e3e05a21eaaa.svg";
export { ForwardRef as ReactComponent };